import { FC, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { DisconnectOutlined, WifiOutlined } from "@ant-design/icons";
import type { Toast } from "antd-mobile";
import styles from "./styles.module.scss";

export interface INetworkBar {
  connectionStatus: boolean;
  toast: typeof Toast;
}

export const NetworkBar: FC<INetworkBar> = ({ connectionStatus, toast }) => {
  const { t } = useTranslation();
  const [connection, setConnection] = useState<INetworkBarStatus>(null);

  useEffect(() => {
    if (connectionStatus && connection === "disconnected") {
      setConnection("connected");
      toast.show({
        content: (
          <div className={styles.connectedToast} data-test-id="bar">
            <WifiOutlined /> {t("networkBar.connectionRestored")}
          </div>
        ),
        position: "bottom",
        maskClassName: styles.mask,
      });
    }
    if (!connectionStatus && connection !== "disconnected") {
      setConnection("disconnected");
      toast.show({
        content: (
          <div className={styles.disconnectedToast} data-test-id="bar">
            <DisconnectOutlined /> {t("networkBar.noConnection")}
          </div>
        ),
        position: "bottom",
        maskClassName: styles.mask,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [connectionStatus, t, toast]);

  return <></>;
};
